<template>
	<v-container fluid>
		
		<v-row>
			<v-col
				v-show 	= "show.add"
				xl 		= "4"
				lg 		= "4"
				md 		= "5"
				sm 		= "5"
				xs 		= "12"
				cols 	= "12"

			>
				<v-card outlined>
				<v-card-title
					:class = "heads.class_title"

				>
					<v-icon
						small
						:color = "heads.color_title"
						:class = "heads.class_icon"
					>
						{{ heads.icon_title}}	
					</v-icon>
					<span>
						{{ heads.title }}
					</span>
				</v-card-title>
				<v-card-text
					:class = "heads.class_text"
				>
					
					<template
						v-for = "(item_field, idx_field) of fields"

					>
						<v-text-field
							dense
							outlined
							hide-details
							:key 			= "'field' + ID_notification + idx_field"
							v-model 		= "info[item_field.key]"
							:label 			= "item_field.text"
							:type 			= "item_field.type"
							:placeholder 	= "item_field.placeholder" 
							v-if 			= "['text', 'number'].includes(item_field.type)"
							:class 			= "item_field.class"
						></v-text-field>
						<v-textarea
							dense
							outlined
							auto-grow
							hide-details
							:key 			= "'field' + ID_notification + idx_field"
							v-model 		= "info[item_field.key]"
							:label 			= "item_field.text"
							:placeholder 	= "item_field.placeholder" 
							v-else-if 			= "['textarea'].includes(item_field.type)"
							:class 			= "item_field.class"
							row-height 		= "10"
							rows 			= "1"
						></v-textarea>

						<v-select
							dense
							outlined
							hide-details
							:key 			= "'field' + ID_notification + idx_field"
							v-model 		= "info[item_field.key]"
							:label 			= "item_field.text"
							:items 			= "item_field.items"
							item-text 		= "text"
							item-value 		= "key"
							:placeholder 	= "item_field.placeholder" 
							v-else-if		= "'select' == item_field.type"
							:class 			= "item_field.class"
						></v-select>
						<v-card 
							outlined 
							class 		= "pa-0 caption pb-1 pl-1 mt-1" 
							height 		= "40"						
							:key 		= "'field' + ID_notification + idx_field"
							v-else-if 	= "item_field.type == 'switch'">
							<v-switch			
								dense						
								hide-details
								class 			= "mt-1"			
								v-model 		= "info[item_field.key]"									
								:label 			= "item_field.text"
								:prepend-icon 	= "item_field.icon"
								:true-value 	= "item_field.value"
							></v-switch>
								
						</v-card>
					</template>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions
					:class = "heads.class_actions"
				>	
					<template
						v-for = "(item_action, idx_action) of actions_options"
					>
						<v-btn
							x-small
							:key 	= "idx_action + ID_notification + 'btns'"
							v-show 	= "show[item_action.key]"
							:color 	= "item_action.color"
							@click 	= "actions(item_action.action, item_action)"
						>
							{{ item_action.text }}
						</v-btn>
						<!-- <v-spacer></v-spacer> -->
					</template>
					
				</v-card-actions>
				</v-card>
			</v-col>
			<v-col>
				<v-toolbar
		    		dense
		    		height 	= "25"
		    		:class  = "heads.class_table"
		    	>
		    		<v-icon
						small
						:color = "heads.color_icon_table"
						:class = "heads.class_icon_table"
					>
						{{ heads.icon_table}}
					</v-icon>
		    		<v-toolbar-title 
		    			class = "body-2"
		    		>
		    			{{ heads.table }}
		    		</v-toolbar-title>
		    			<v-spacer></v-spacer>

		    			<v-tooltip
		    				top
		    			>
		    				<template
		    					v-slot:activator = "{ on }"
		    				 >
		    					
				    			<v-btn
				    				x-small
				    				fab
				    				height 	= "25"
				    				width 	= "25"
				    				class 	= "mr-3"
				    				:color  = "!show.add_unlisted ? 'primary' : 'error'"
				    				@click 	= "actions('add_unlisted')"
				    				:disabled = "show.add_unlisted"
				    				v-on 		= "on"
				    			>
				    				<v-icon
				    					small
				    				>

				    					{{ !show.add_unlisted ? 'mdi-book-plus' : 'mdi-book-open-page-variant' }} 
				    				</v-icon>
				    			</v-btn>
		    				</template>
		    				<span>
		    					{{ heads.tooltip_unlisted }}
		    				</span>
		    			</v-tooltip>
		    			<v-tooltip
		    				top
		    			>
		    				<template
		    					v-slot:activator = "{ on }"
		    				 >
				    			<v-btn
				    				x-small
				    				fab
				    				height 	= "25"
				    				width 	= "25"
				    				:color  = "!show.add ? 'primary' : 'error'"
				    				@click 	= "actions('show_add')"
				    				v-on 	= "on"

				    			>
				    				<v-icon
				    					small
				    				>

				    					{{ !show.add ? 'mdi-plus' : 'mdi-close' }} 
				    				</v-icon>
				    			</v-btn>
				    		</template>
		    				<span>
		    					{{ heads.tooltip_add_resource }}
		    				</span>
		    			</v-tooltip>
		    	</v-toolbar>
				<v-data-table
					dense
				    fixed-body
				    fixed-header
					class 				 = "elevation-5"
					:items 				 = "resources"
					:headers 			 = "header"
					:options.sync 		 = "options"
				   	:server-items-length = "total"
				   	loading-text 		 = "Loading... Please wait"
				   	:loading 			 = "loading"
				    item-key 			 = "id"
				    :height  			 = "(layout_height - 200) + 'px'"
				   	:footer-props  		 = "{
				   		// showFirstLastPage 	: true,
				   		itemsPerPageOptions : [/*15, 30*/],
				   		showCurrentPage 	: true,
				   		itemsPerPageText 	: ''
				   	}"
				   	
				>
					<template 
						v-for = "(item_resource, idx_resource) of resource_options"
						v-slot:[`item.${item_resource.key}`] = "{ item, index }" 
					>

						<v-btn
							x-small
							:key 	= "'resource_options' + item_resource.key + idx_options_resr"
							v-for 	= "(item_option_resr, idx_options_resr) of item_resource.options"
							:color  = "item_option_resr.color"
							@click 	= "actions(item_option_resr.action, item, index)"
						>
							<v-icon
								x-small
							>
								{{ item_option_resr.icon }}
							</v-icon>
						</v-btn>	
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>  

	export default {
		name 		: "resources",
		data 		: (vm) => ({
			info 		: {},
			list 		: [],
			header  	: [
				{ text : vm.$ml.get("type"), value : "type" },
				{ text : vm.$ml.get("name"), value : "name" },
				{ text : vm.$ml.get("description"), value : "description" },
				{ text : vm.$ml.get("state"), value : "state" },				
				{ text : "actions" , value : "actions" }, 
			],
			info_item 	: null,
			heads  	: {
				title 				: vm.$ml.get("new"),
				class_title 		: "body-2 pa-1 primary",
				icon_title 			: "mdi-folder-plus",
				icon_color_title  	: "white",
				class_icon  		: "mx-1",
				class_text  		: "pa-1 px-2",
				icon_table  		: "mdi-view-list",
				class_table 		: "secondary white--text",
				table 				: vm.$ml.get("registered_resources"),
				class_icon_table 	: "mr-1",
				color_icon_table  	: "white",
				class_actions 		: "d-flex justify-space-between",
				tooltip_unlisted  	: vm.$ml.get("add_unlisted_resources"),
				tooltip_add_resource : vm.$ml.get("new_resource"),
			},
			show  		: {
				add 			: false,
				save 			: true,
				update 			: false,
				close_add 		: true,
				add_unlisted 	: false,
			},
			fields 		: [
				{
					key  	: "type",
					type 	: "select",
					class  	: "mt-2",
					text 	: vm.$ml.get("type"),
					item_text 	: "text",
					item_value 	: "key", 
					items 	: [
						{
							key  : "route",
							text : vm.$ml.get("route")
						},
						{
							key  : "component",
							text : vm.$ml.get("component")
						},
						{
							key  : "api",
							text : vm.$ml.get("api")
						},
						{
							key  : "module",
							text : vm.$ml.get("module"),
						}
					],

				},
				{
					key  	: "name",
					type 	: "text",
					class  	: "mt-2",
					text 	: vm.$ml.get("name"),

				},

				{
					key  	: "description",
					type 	: "textarea",
					class  	: "mt-1",
					text 	: vm.$ml.get("description"),
				},
				{
					key  	: "state",
					type 	: "switch",
					class  	: "mt-2 pl-1 ",
					text 	: vm.$ml.get("state"),

				},

			],
			actions_options	 : [
				{
					key 	: "save",
					action 	: "save",
					color 	: "primary",
					text 	: vm.$ml.get("save"), 
				},
				{
					key 	: "update",
					action 	: "update",
					text 	: vm.$ml.get("update"),
					color 	: "primary",
				},
				{
					key 	: "close_add",
					action 	: "close_add",
					text 	: vm.$ml.get("close"),
					color 	: "error",
				}
			], 
			resource_options : [
				{
					key 	: "actions",
					type 	: "btn",
					options : [
						{
							key 	: "edit",
							icon 	: "mdi-pencil",
							action 	: "edit",
							color 	: "primary",
						}, 
						{
							key 	: "delete",
							icon 	: "mdi-delete",
							action  : "delete",
							color 	: "error",
						}
						], 
				} 
			],
			layout_height 	: 400,
			options 		: { itemsPerPage : 30 },
			total 			: 0,
			loading 		: false,
			ID_notification : "resources",
			bus 			: {},

		}), // data

		created(){

		}, // created
		watch : {
			options : {
				handler(){
					this.get_list();
				},
				deep : true
			}, // options
		}, // watch

		computed : {
			resources: function(){
				return this.list;
			}, // resources
		}, // compunted

		methods : {
			actions(act, item, opt ){
				// console.log("actions  ", act, "\n item ", item , "\n option ", opt);

				if (act == 'edit') {
					this.info 			= { ...item };
					this.info_item 		= opt;
					this.show.add 		= true;
					this.show.update 	= true;
					this.show.save 		= false;
				}else if (act == 'save') {
					this.save();
				}else if (act == 'update') {
					this.update()
				}else if (act == 'delete') {
					this.info_item 	= opt;
					this.info 		= { ...item };

					this.$EventBus.$emit("notifications_modal", {
						type 	:  "confirm_delete",
						ID 		: this.ID_notification,
					})
				}else if (act == 'show_add') {
					this.show.add = !this.show.add; 
					this.show.update 	= false;
					this.show.save 		= true;
				}else if (act == "close_add") {
					this.show.add 	= !this.show.add; 
					this.info 	  	= {};
					this.info_item 	= null;

				}else if (act == "add_unlisted") {
					this.show.add_unlisted = true;
					this.$EventBus.$emit("notifications_modal", {
						type 	: "confirm_options",
						ID   	: this.ID_notification,
						message : this.$ml.get("add_unlisted_resources"),
						action  : { action : "create_unlisted"}
					})
				}else if(act == "create_unlisted") {
					this.create_ullisted();
				}
			}, // actions 

			get_list(){
				this.loading 	= true;
				const { page } 	= this.options;
				const api 		= this.$URL + "/api/v1/resource/?page=" + page;				
				this.$axios.get(api).then(res => {
					if (res && res.data && res.data.rows && res.data.rows.length > 0) {
						this.list  = [ ...res.data.rows ];
						this.total = res.data.count;

					}
					this.loading = false;
				}).catch(err => {
					console.log("Error get resources : ", err);
					this.loading =  false;
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err,
					})
				})
			}, // get list

			save(){
				this.loading 	= true;
				const { page } 	= this.options;
				const api 		= this.$URL + "/api/v1/resource";			
				let info_up 	= { ...this.info };

				this.$axios.post(api, info_up).then(res => {					
					this.$EventBus.$emit("notifications_modal",{
						type 	: "saved",						
					});
					if (res && res.data) {
						this.list.push({ ...res.data });
					}

					this.info =	 {};
			        this.$store.dispatch('auth/list_permissions');
					this.actions("close_add");

					this.loading = false;
				}).catch(err => {
					console.log("Error create resource : ", err);
					this.loading =  false;
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err,
					})
				})
			}, // save

			update(){
				this.loading 	= true;				
				let info_up 	= { ...this.info };
				if (info_up && info_up.id) {

					const api 		= this.$URL + "/api/v1/resource/" + info_up.id;				
					this.$axios.put(api, info_up).then(res => {
						this.list.splice(this.info_item , info_up); 
						this.loading = false;
						this.actions("close_add");
						this.$EventBus.$emit("notifications_modal",{
							type 	: "updated",						
						})
					}).catch(err => {
						console.log("Error update resource : ", err);
						this.loading =  false;
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : err,
						})
					})
				}else{
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("required") + " " + this.$ml.get("id"), 
					});
				}
			}, // update

			del(){
				this.loading 	= true;
				if (this.info && this.info.id) {

					const api 		= this.$URL + "/api/v1/resource/" + this.info.id;				
					this.$axios.delete(api).then(res => {
						if (res && res.data) {

						}
						this.list.splice(this.info_item, 1);					
						// this.actions("close_add");
						this.loading 	= false;
						this.$EventBus.$emit("notifications_modal",{
							type 	: "deleted",					
						})

					}).catch(err => {
						console.log("Error delete resource : ", err);
						this.loading =  false;
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : err,
						})
					});
				}else{
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("required") + " " + this.$ml.get("id"), 
					});
				}
			}, // del

			create_ullisted(){
				
				const api 	  	= this.$URL + "/api/v1/resource";
				// let list_temp 	= [];
				// let list_check 	= this.$store.getters["auth/list_default_resources"];
				this.$store.dispatch("auth/diff_resources", {
					resources : this.list,
				}).then(res=>{
					let list_temp 		=  res;	
					// console.log("CHECK LIST TEMP ", list_temp)
					// if (list_check && list_check.length > 0) {

					// list_temp 		= list_check.filter( x => ( x && !x.id ));
				 		// console.log("items filters ", list_check.filter( x => ( x && x.enable)))
				 	if (list_temp && list_temp.length > 0) {
						// this.loading  	= true;
						let count = 0;

						list_temp.forEach(async (item, idx, len)=>{
							if (item && item.type_component == "module") {
								count++;
								let info_up = {
									name  : item.module || item.name,
									type  : item.type_component,
									state : item.enable,
									description : "route permissions " + item.module, 
								};
								let resp = await this.$axios.post(api, info_up).then(res => {
									if (res && res.data) {
										this.list.push({ ...res.data });

									}
									if (idx == len.length - 1 ) {
										this.loading 			= false;
										this.show.add_unlisted 	= false;
										
										this.$EventBus.$emit("notifications_modal",{
											type  	: "saved",									
										});
									
									}
									return true
								}).catch(er => { 
									console.log("error create list ")
									if (idx == len.length - 1 ) {
										this.loading 			= false;
										this.show.add_unlisted 	= false;

									}
								})
							}
							if(count == 0 && idx == len.length - 1){
								this.loading 			= false;
								this.show.add_unlisted 	= false;
								this.$EventBus.$emit("notifications_modal",{
									type  	: "success",
									message : this.$ml.get("not_found_items_add")									
								});
							}
							
						})
				 	}else{
						this.show.add_unlisted = false;
						this.$EventBus.$emit("notifications_modal",{
							type  	: "success",
							message : this.$ml.get("not_found_items_add")									
						})
				 	}
				});
				/*}else{
				 	console.log("items defaults")
					this.show.add_unlisted = false;			
					this.$EventBus.$emit("notifications_modal",{
						type  	: "success",
						message : this.$ml.get("not_found_items_add")									
					})		
				}*/
				
			}, // created unlisted


		}, // methods

		mounted(){
			let temp = "notifications_modal" + this.ID_notification 
			this.$EventBus.$on(temp ,this.bus[temp] = (action, action2) =>{
				console.log("RES notifications_modal ", action, action2)
				if (action2) {
					if (action2.action && action)  {
						console.log("add add_unlisted actions", )
						this.actions(action2.action, action2);
					}else
					if (action2.action == "create_unlisted") {
						this.show.add_unlisted = false;
					}
				}else
				if (action) {

					this.del();
				}

			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, "resources");
		}
	};
</script>